import React, { useEffect, useState } from 'react'

import { Icon } from '../../../components/Icon'
import { WhistleblowingHeaders, policyHeader } from '../../../data/index'
import Menu from '../../../components/UI/UIMenu'
import Modal from '../../../components/UI/UIModal'
import UIButton from '../../../components/UI/UIButton'
import UITextArea from '../../../components/UI/UITextArea'
import UITextInput from '../../../components/UI/UITextInput'
import UIRadiobutton from '../../../components/UI/UIRadiobutton'
import WhistleBlowingAboutOfficer from '../../../components/WhistleBlowingAboutOfficer'
import UISubHeaderComponent from '../../../components/UI/UISubHeaderComponent'

import {
  addWistleBlowingComments,
  createWhistleBlowing,
  getWhistleBlowingCandidate,
  getWistleBlowingComments,
} from '../../../api/candidate/whistleBlowing'
import {
  whistleBlowing,
  whistleblowingComment,
  whistleblowingCommentResponse,
  whistleblowingData,
  whistleblowingResponse,
  whistleblowingResponseObj,
} from '../../../utils/types'
import { toast } from 'react-toastify'
import { useQuery, useQueryClient } from 'react-query'
import {
  capitalizeFirstLetter,
  formatDate,
  statusBgColorWhistleblowing,
} from '../../../utils/utils'

interface WhistleblowingHeadersInterface {
  ID: string
  Status: string
  Subject: string
  'Report Type': string
  'Date Reported': string
  'Updated At': string
  'Created By': string
  'Updated By': string
}

const WhistleblowingCandidate = () => {
  const [whistleBlowingViewData, setWhistleBlowingViewData] =
    useState<whistleblowingData>()
  const queryClient = useQueryClient()
  const [id, setId] = useState('')
  const [isOpen, setIsOpen] = useState(false)
  const [isView, setIsView] = useState(false)

  const [isConfidentialSelected, setIsConfidentialSelected] = useState(false)
  const [isAnonymousSelected, setIsAnonymousSelected] = useState(false)
  const [aboutOfficer, setAboutOfficer] = useState(false)
  const [comment, setComment] = useState('')
  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('reportNo')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }
  const handleConfidentialClick = () => {
    setIsConfidentialSelected(true)
    setIsAnonymousSelected(false)
  }

  const handleAnonymousClick = () => {
    setIsConfidentialSelected(false)
    setIsAnonymousSelected(true)
  }
  const [description, setDescription] = useState<string>('')
  const [subject, setSubject] = useState<string>('')

  const handleToggleMenu = (rowIndex: number) => {
    const updatedMenuState = isOpenMenu.map((isOpen, index) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const handleOpenModal = () => {
    setIsOpen(true)
  }

  const handleCloseModal = () => {
    setIsOpen(false)
  }

  const getWhistleBlowingData =
    async (): Promise<whistleblowingResponseObj> => {
      const response = (await getWhistleBlowingCandidate(
        // currentPage,
        sortBy,
        sortOrderValue
      )) as whistleblowingResponse

      if (response?.status != 'successful') {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
      return response?.data
    }

  const getwhistleBlowingComments = async (): Promise<
    whistleblowingComment[]
  > => {
    const response = (await getWistleBlowingComments(
      id
    )) as whistleblowingCommentResponse

    if (response?.status != 'successful') {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
    return response?.data
  }

  const whistleBlowing = useQuery('whistleBlowing', getWhistleBlowingData)

  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(whistleBlowing.data?.data?.length || 100).fill(false)
  )
  const whistleBlowingComment = useQuery(
    ['whistleblowinComment', id],
    getwhistleBlowingComments,
    {
      enabled: !!id, // Only fetch data when id is truthy
    }
  )

  const createWhistle = async (): Promise<void> => {
    const response = (await createWhistleBlowing({
      // Anonymous reports must not carry the reporter's email
      email: isConfidentialSelected
        ? localStorage.getItem('userEmail') || ''
        : '',
      subject: subject,
      description: description,
      reportType: isConfidentialSelected == true ? 'user' : 'anonymous',
      aboutOfficer,
    })) as {
      status?: string
      data: whistleBlowing
    }
    if (response?.status == 'successful') {
      // setIsOpen(!isOpen)
      handleCloseModal()
      setAboutOfficer(false)
      whistleBlowing.refetch()
      toast.success('Whistleblowing Record Created.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }
  const addComment = async (): Promise<void> => {
    const response = (await addWistleBlowingComments(
      {
        comment: comment,
      },
      id
    )) as {
      status?: string
      data: whistleblowingData
    }
    if (response?.status == 'successful') {
      whistleBlowingComment.refetch()
      // setIsOpen(!isOpen)
      setComment('')
      toast.success('Comment Added.', {
        position: 'top-right',
      })
    } else {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }
  useEffect(() => {
    whistleBlowing.refetch() // Refetch Whistle Blowing when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  return (
    <div
      className={'flex flex-col gap-3 w-full bg-white  h-full rounded-3xl p-8 '}
    >
      {!isView && (
        <div className="flex flex-col w-full relative h-full">
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[50%] gap-[20px]">
              <p className={'text-[18px] text-text2 font-bold '}>
                Whistleblowing
              </p>
            </div>

            <div className={'flex flex-row gap-[15px]'}>
              <div className={'flex flex-row gap-[15px]'}>
                <div
                  onClick={handleOpenModal}
                  className="gap-[10px]  bg-bluishGreen items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px] cursor-pointer"
                >
                  <p className={'font-medium text-[14px] text-white'}>
                    Create Report
                  </p>
                  <Icon
                    name={'IconPlus'}
                    strokeWidth={1}
                    stroke={'white'}
                    width={16}
                    height={16}
                  />
                </div>
              </div>
            </div>
          </div>
          <>
            <div id={'#container'} className="w-full flex mt-6">
              {/* table component */}
              <div className="overflow-hidden rounded-[16px] w-full">
                <table className="rounded-[16px] overflow-hidden border w-full border-white">
                  <thead>
                    <tr className="bg-gray2 cursor-pointer">
                      {WhistleblowingHeaders?.map((item, index: number) => {
                        return (
                          <th
                            key={index}
                            className={`w-1/8 px-4 py-3 text-left ${policyHeader?.length - 1 === index ? 'border-0 border-gray2' : 'border border-white'}`}
                          >
                            <div className="flex items-center">
                              <p className="text-text1 font-semibold text-sm flex-1">
                                {item.replace(/_/g, ' ')}
                              </p>
                              <div
                                className="cursor-pointer"
                                onClick={() => {
                                  let sortBy = ''
                                  switch (
                                    item as keyof WhistleblowingHeadersInterface
                                  ) {
                                    case 'ID':
                                      sortBy = 'reportNo'
                                      break
                                    case 'Status':
                                      sortBy = 'status'
                                      break
                                    case 'Subject':
                                      sortBy = 'subject'
                                      break
                                    case 'Report Type':
                                      sortBy = 'reportType'
                                      break
                                    case 'Date Reported':
                                      sortBy = 'createdAt'
                                      break
                                    case 'Updated By':
                                      sortBy = 'updatedByName'
                                      break
                                    case 'Updated At':
                                      sortBy = 'updatedAt'
                                      break
                                    default:
                                      break
                                  }
                                  handleSort(sortBy)
                                }}
                              >
                                <Icon
                                  name={'IconChevronDown'}
                                  width={16}
                                  height={16}
                                  strokeWidth={1}
                                  stroke={'#67A5B9'}
                                />
                              </div>
                            </div>
                          </th>
                        )
                      })}
                      <th className="w-1/8 px-4 py-3 border text-left border-white"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {whistleBlowing?.data?.data?.map((item, index) => (
                      <>
                        <tr className="bg-gray1">
                          {/* Example row */}
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            {index + 1}
                          </td>
                          <td className="px-4 h-[48px] py-2 border border-white">
                            <div
                              className={`px-[10px] w-fit flex justify-center items-center bg-${statusBgColorWhistleblowing(item.status)} h-[28px] rounded-[100px]`}
                            >
                              <p className="text-text2  font-medium text-xs leading-5">
                                {capitalizeFirstLetter(item.status || '')}
                              </p>
                            </div>
                          </td>
                          <td className="px-4 h-[48px] py-2 border border-white">
                            <p className="text-text1 font-semibold text-sm leading-6">
                              {item.subject}
                            </p>
                          </td>
                          <td className="px-4 h-[48px] py-2 border border-white">
                            <p className="text-text1 font-semibold text-sm leading-6">
                              {item.reportType}
                            </p>
                          </td>
                          <td className="px-4 h-[48px] py-2 border border-white">
                            <p className="text-text1 font-semibold text-sm leading-6">
                              {formatDate(item.createdAt)}
                            </p>
                          </td>
                          <td className="px-4 h-[48px] py-2 border border-white">
                            {item.updatedByName ? (
                              <p className="text-xs text-text1 font-medium leading-5">
                                {item.updatedByName}
                              </p>
                            ) : (
                              <p className="text-xs text-text1 font-medium leading-5">
                                Awaiting Update
                              </p>
                            )}
                          </td>
                          <td className="px-4 h-[48px] py-2 border border-white">
                            <p className="text-text1 font-semibold text-sm leading-6">
                              {formatDate(item.updatedAt)}
                            </p>
                          </td>

                          <td className="px-4  py-2 border border-white cursor-pointer flex items-center h-[65px] justify-center">
                            <Menu
                              isOpen={isOpenMenu[index]}
                              items={[
                                {
                                  label: 'View',
                                  onClick: () => {
                                    setIsView(true)
                                    setId(item.id)
                                    setWhistleBlowingViewData(item)
                                    queryClient.fetchQuery([
                                      'whistleblowinComment',
                                      item?.id,
                                    ])
                                    handleToggleMenu(index)
                                  },
                                  icon: 'IconEye',
                                  iconColor: '',
                                },
                              ]}
                              type={'table'}
                              setIsOpenMenu={setIsOpenMenu}
                              isOpenMenus={isOpenMenu}
                            >
                              <div onClick={() => handleToggleMenu(index)}>
                                <Icon
                                  name={'IconDotsVertical'}
                                  width={16}
                                  height={16}
                                  strokeWidth={1.5}
                                  stroke={'#02698C'}
                                />
                              </div>
                            </Menu>
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        </div>
      )}
      {isView && (
        <div style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}>
          <UISubHeaderComponent
            mainPage="Whistleblowing"
            subPage={`Whistleblowing ID ${whistleBlowingViewData?.reportNo}`}
            copy="Please add your whistleblowing reports here. You can give various reasons and solutions, and specify their severity level."
            isViewMode={false}
            onBack={() => {
              setIsView(false)
            }}
          />

          {/* content container */}

          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    ID
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingViewData?.reportNo}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Status
                  </td>
                  <td className="px-4  h-[48px] py-2 border border-white">
                    <div
                      className={`px-4 rounded-[72px] w-fit py-2 bg-${statusBgColorWhistleblowing(whistleBlowingViewData?.status || '')}  flex justify-center items-center`}
                    >
                      <p className="text-text2 font-medium text-xs leading-5">
                        {capitalizeFirstLetter(
                          whistleBlowingViewData?.status || ''
                        )}
                      </p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Subject
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingViewData?.subject}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Description
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingViewData?.description}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Report Type
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {whistleBlowingViewData?.reportType}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Created at
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {formatDate(whistleBlowingViewData?.createdAt || '')}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Updated at
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {formatDate(whistleBlowingViewData?.updatedAt || '')}
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>

          <p className={'text-text2 text-[14px] font-semibold'}>Comments</p>

          {whistleBlowingComment?.data?.map((item, index: number) => (
            <div
              key={index}
              className="overflow-hidden rounded-[16px] w-full my-[30px]"
            >
              <table className="rounded-[16px] overflow-hidden border w-full border-white">
                <tbody>
                  <tr className="bg-gray1">
                    {/* Example row */}
                    <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                      Created at
                    </td>
                    <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                      {item.createdAt?.substring(0, 16)}
                    </td>
                  </tr>
                  <tr className="bg-gray1">
                    {/* Example row */}
                    <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                      User wrote
                    </td>
                    <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                      {item.comment}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          ))}

          <UITextArea
            label={'Post a comment'}
            placeholder="Please describe the details of your report"
            iconName={''}
            value={comment}
            onChange={(e) => {
              setComment(e.target.value)
            }}
          />
          <div className="w-[100%] bg-lightGreen rounded-xl mt-3 h-[72px] flex-col py-4 px-5">
            <p className="text-text2 text-sm font-semibold leading-6">
              Confidential Comments:
            </p>
            <p className="text-text1 text-sm font-normal leading-6">
              Your name will appear on comments posted.
            </p>
          </div>
          <div className="bg-gray3 w-full h-[1px] my-3"></div>
          <div className="w-[33%] mt-6">
            <UIButton onClick={addComment} label="Post Comment" />
          </div>
        </div>
      )}
      {/* Create report modal */}
      <Modal
        customStyle={{ borderRadius: 16, padding: '20px 16px' }}
        isOpen={isOpen}
        onClose={handleCloseModal}
      >
        <div
          className={
            'w-[480px] max-h-[80vh] min-h-[45vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconMessageAlertSquare'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Submit a Whistleblowing Report
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please fill out the following fields
            </p>
          </div>
          <div className="w-full flex-col flex gap-4 mt-3">
            <div>
              <UITextInput
                iconName={''}
                label="Subject*"
                placeholder="Subject"
                onChange={(e) => {
                  setSubject(e.target.value)
                }}
              />
            </div>
            <div>
              <UITextArea
                label="Description*"
                placeholder="Write description here"
                onChange={(e) => {
                  setDescription(e.target.value)
                }}
              />
            </div>
            <UIRadiobutton
              label={'Report confidentially'}
              checked={isConfidentialSelected}
              onChange={handleConfidentialClick}
              desc="You can choose to report confidentially. Your identity will only
                be known to those who handle your case in confidence, and your
                identity will appear anonymous and confidential to others in
                case processing."
            />
            <UIRadiobutton
              label={'Report anonymously'}
              checked={isAnonymousSelected}
              onChange={handleAnonymousClick}
              desc="You can choose to report anonymously if you prefer not to provide your identity to anyone in the process."
            />
            <WhistleBlowingAboutOfficer
              checked={aboutOfficer}
              onChange={setAboutOfficer}
            />
          </div>
          <div className="w-full mt-4">
            <UIButton
              onClick={() => {
                createWhistle()
              }}
              label="Submit"
            />
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default WhistleblowingCandidate
